import { LAST_MESSAGES, SET_OTHER_PERSON_ID, GET_MESSAGE_BY_PERSON, IS_LOADING, UPDATE_PERSONS_FOR_MESSAGES, SEND_MESSAGE, INBOX_TEXT_CHANGED} from '../constants/ActionTypes';
import { updatePersonsAction } from './CommunityActions';
import * as ApiUtils from '../views/reactViews/ApiUtil';
import _ from 'underscore';
import pubSub from '../PubSub';


function getLastMessagesAction(response) {
    return {
        type: LAST_MESSAGES,
        response
    };
}

function loadingAction(isLoading) {
    return {
        type: IS_LOADING,
        isLoading: isLoading
    };
}

function getMessagesByPersonAction(messagesByPerson, otherPersonId) {
    return {
        type: GET_MESSAGE_BY_PERSON,
        messagesByPerson,
        otherPersonId
    };
}

function sendMessageAction(message, otherPersonId) {
    return {
        type: SEND_MESSAGE,
        message,
        otherPersonId
    };
}

function textChangedAction(text, otherPersonId) {
    return {
        type: INBOX_TEXT_CHANGED,
        text,
        otherPersonId
    };
}

function getLastMessages(options = {}) {

    return (dispatch, getState) => {
        options.success = function(response) {
            let lastMessages = response ? response : [];
            let peopleIds = [];
            lastMessages.forEach(function(msg) {
                var personId = (msg.targetId == getState().meReducer.me.id) ? msg.sourceId : msg.targetId;
                msg['other-person-id'] = personId;
            });
            if (options.otherPersonId && !_.contains(peopleIds, options.otherPersonId)) {
                lastMessages.push({
                    'other-person-id': options.otherPersonId
                });
            }
            lastMessages = (lastMessages || []).reverse();
            let users = [];
            lastMessages.forEach(function(msg) {
                msg.person = msg.userProfile;
                msg.userProfile && users.push(msg.userProfile);
            });
            lastMessages = _.filter(lastMessages, function(msg) {
                return (typeof msg.person !== 'undefined');
            });
            dispatch(updatePersonsAction({users: users}));
            dispatch(getLastMessagesAction(lastMessages));
            dispatch(getMessagesByPerson({
                targetId: options.otherPersonId,
                eventId: options.eventId
            }));
        };
        options.error = function(response) {
            dispatch(loadingChanged(false));
        };

        return ApiUtils.getLastMessages(options);
    };
}

function loadingChanged(isLoading) {
    return (dispatch, getState) => dispatch(loadingAction(isLoading));
}


function getMessagesByPerson(options) {
    return (dispatch, getState) => {
        let state = getState();
        options.success = function(response) {
            let messages = response ? response : [];
            let ids = [];
            _.each(messages, function(message) {
                if (!message.read && message.targetId === state.meReducer.me.id) {
                    ids.push(message.id);
                    message.read = true;
                }
            }, this);
            options.ids = ids;
            options.success = function() {
                _.delay(function() {
                    pubSub.publish('fetchBadge');
                }, 1500);
            };
            ApiUtils.markMessagesAsRead(options);
            messages = messages.reverse();
            dispatch(getMessagesByPersonAction(messages, options.targetId));
        };
        options.error = function(response) {
        };
        return ApiUtils.getMessagesByPerson(options);
    };
}


function sendMessage(options) {
    return (dispatch, getState) => {
        options.text = getState().inboxReducer.currentMessageText[options.targetId] || '';
        dispatch(sendMessageAction('', options.targetId));
        options.success = function(response) {
            dispatch(sendMessageAction(response, options.targetId));
            pubSub.publish('analytics:SentMessage', options.targetId, options.fullName);
        };
        options.error = function(response) {
            dispatch(textChangedAction(options.text, options.targetId));
        };
        return ApiUtils.sendMessage(options);
    };
}

function textChanged(text, otherPersonId) {
    return (dispatch, getState) => dispatch(textChangedAction(text, otherPersonId));
}

export {
    loadingChanged,
    getLastMessages,
    getMessagesByPerson,
    sendMessage,
    textChanged
};


